import React from 'react';
import { Typography, Box, IconButton, Tooltip } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

/** Kop van de mobiele navigatielade: logo, naam en sluitknop. */
export default function NavDrawerHeader({ onClose }) {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <img
          src="/logo192.png"
          alt="BEM.report Logo"
          style={{
            width: 24,
            height: 24,
            borderRadius: '4px',
            filter: 'brightness(0) invert(1)',
          }}
        />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          BEM.report
        </Typography>
      </Box>
      <Tooltip title="Menu sluiten">
        <IconButton
          aria-label="Menu sluiten"
          onClick={onClose}
          sx={{ color: 'primary.contrastText' }}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
